export function convertCountDown(timeInSeconds) {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = timeInSeconds % 60;

    return {hours, minutes, seconds};
}

export function calculatePeriodLabelFromNumberOfDays(numberOfDays) {
    let label;
    if (numberOfDays % 7 === 0) {
        const weeks = numberOfDays / 7;
        label = `${weeks} settiman${weeks > 1 ? 'e' : 'a'}`;
    } else {
        label = `${numberOfDays} giorn${numberOfDays > 1 ? 'i' : 'o'}`;
    }
    return label;
}

//20250325 - Impostato false perché in staging ci sono le chiavi PayPal di produzione. Rimuovere il false e il commento se si vuole il comportamento corretto
export const isInDebugMode = process.env.NODE_ENV === 'development' || (window.location.hostname === 'shop.staging.giocamondo.it') || (window.location.hostname === 'shop-bis.staging.giocamondo.it');

// Ancora della sezione "Dati del Genitore", primo campo che l'utente
// compila se sceglie di non registrarsi.
export const BOOKING_FORM_ANCHOR_ID = 'inserimentoDati'

// Porta l'utente alla sezione senza sporcare l'URL con l'hash e tenendo
// conto dell'header fisso, che altrimenti coprirebbe il titolo.
export function scrollToBookingForm() {
    const el = document.getElementById(BOOKING_FORM_ANCHOR_ID)
    if (!el) {
        return
    }

    const header = document.querySelector('header.MuiAppBar-root')
    const offset = (header ? header.getBoundingClientRect().height : 0) + 16
    const top = el.getBoundingClientRect().top + window.pageYOffset - offset

    window.scrollTo({top: top > 0 ? top : 0, behavior: 'smooth'})

    // Chi naviga da tastiera deve ritrovarsi il focus nella sezione,
    // non rimasto sul link appena lasciato.
    el.setAttribute('tabindex', '-1')
    el.focus({preventScroll: true})
}
